/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import Order from '../../../interfaces/forms/Order';
import Filter from '../../../interfaces/forms/Filter';
import { PlatformIccidPoolNumber } from '../../../interfaces/platform/PlatformIccidPoolNumber';
import { TableBody, TableHead } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../../components/Translate/I18n';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import ViewButton from '../../../components/Buttons/ViewButton';
import { IccidMvnoStatusHelper } from '../../lib/search/IccidMvnoStatusHelper';
import { SimCardTypeHelper } from '../../../modules/storage/SimCardTypeHelper';
import i18next from 'i18next';
import { SimCardMnoTariffLoader } from '../../../modules/tariffs/SimCardMnoTariffLoader';
import { IccidState } from '../imsi/IccidState';
import { iccidStatus } from '../../../helpers/iccidStatus';
import OPL_STYLE from '../../../assets/themes/OPL/OplStyle';
import { HeaderCheckBoxSelectListElement } from '../../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { DateHelperTs } from '../../../helpers/DateHelperTs';

export type StorageIccidPartnerUserItemType = {
    classes: any;
    poolItems: Array<PlatformIccidPoolNumber> | null;
    viewCallback: (iri: { uri: string }, event: any) => void;
    firstLoad: () => void;
    setActiveRow: (id: number) => void;
    activeRow: number;
    updateOrderList: (orders: Array<Order>) => void;
    updateFilterList: (filters: Array<Filter>) => void;
    filters: Array<Filter>;
    orders: Array<Order>;
    iccidStatusHelper: IccidMvnoStatusHelper;
    simCardMnoTariffLoader: SimCardMnoTariffLoader;
};

export const StorageIccidPartnerUserItem: FunctionComponent<StorageIccidPartnerUserItemType> = ({
    poolItems,
    classes,
    viewCallback,
    updateOrderList,
    updateFilterList,
    setActiveRow,
    activeRow,
    firstLoad,
    filters,
    orders,
    iccidStatusHelper,
    simCardMnoTariffLoader,
}): React.ReactElement | null => {
    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };
    const tableStickyCommand = { root: classes.tableStickyCommand };
    const [statusList, setStatusList] = useState<Array<HeaderCheckBoxSelectListElement> | null>(null);

    useEffect(() => {
        if (!statusList) {
            const status = new IccidState();
            setStatusList(status.getStatusList());
        }
    }, [statusList]);

    return (
        <React.Fragment>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableStickyCommand} padding="none" align="left">
                        <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.iccid"
                            fieldName="iccid"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.imsi"
                            fieldName="imsi"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.iccid_type"
                            fieldName="iccidType"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerCheckBoxSimpleList"
                            elementList={SimCardTypeHelper.getList()}
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.msisdn"
                            fieldName="msisdnAll"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                            nullable={true}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:sim.iccid_state"
                            fieldName="iccidState"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerCheckBoxSimpleList"
                            elementList={statusList}
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                            nullable={true}
                        />
                    </TableCell>
                    {/*<TableCell classes={tableStickyHeader} padding="none" align="left">*/}
                    {/*    <TableHeaderContentCell*/}
                    {/*        title="pools:pool.mvno_tariff"*/}
                    {/*        textAlign="left"*/}
                    {/*        fieldName="defaultTariff"*/}
                    {/*        showSort={true}*/}
                    {/*        onlyFilter={false}*/}
                    {/*        defaultDirection="desc"*/}
                    {/*        searchFieldType="select"*/}
                    {/*        selectComponent="headerCheckBoxSimpleList"*/}
                    {/*        elementList={simCardMnoTariffLoader.getHeaderList()}*/}
                    {/*        filters={filters}*/}
                    {/*        sort={orders}*/}
                    {/*        updateOrderList={updateOrderList}*/}
                    {/*        updateFilterList={updateFilterList}*/}
                    {/*        searchActionCallback={firstLoad}*/}
                    {/*        nullable={true}*/}
                    {/*    />*/}
                    {/*</TableCell>*/}
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.puk1"
                            fieldName="puk1"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.puk2"
                            fieldName="puk2"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.pin1"
                            fieldName="pin1"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.pin2"
                            fieldName="pin2"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="pools:pool.esimUpdate"
                            fieldName="esimUpdate"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="asc"
                            searchFieldType="date"
                            dateFormat="RRRR-MM-DD"
                            dateFromTo={true}
                            filters={filters}
                            sort={orders}
                            breakLine={true}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                            nullable={true}
                        />
                    </TableCell>
                    {/*<TableCell classes={tableStickyHeader} padding="none" align="left">*/}
                    {/*    <TableHeaderContentCell*/}
                    {/*        textAlign="left"*/}
                    {/*        title="simcard:list.status_mvno"*/}
                    {/*        fieldName="mvnoStatus"*/}
                    {/*        showSort={true}*/}
                    {/*        onlyFilter={false}*/}
                    {/*        defaultDirection="desc"*/}
                    {/*        searchFieldType="select"*/}
                    {/*        selectComponent="headerCheckBoxSimpleList"*/}
                    {/*        elementList={iccidStatusHelper.getList()}*/}
                    {/*        filters={filters}*/}
                    {/*        sort={orders}*/}
                    {/*        updateOrderList={updateOrderList}*/}
                    {/*        updateFilterList={updateFilterList}*/}
                    {/*        searchActionCallback={firstLoad}*/}
                    {/*        nullable={true}*/}
                    {/*    />*/}
                    {/*</TableCell>*/}
                </TableRow>
            </TableHead>
            <TableBody>
                {poolItems?.map((item) => {
                    let rowActiveColor = 'white';
                    if (activeRow === item.id) {
                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                    }
                    let statusString: string | null = item.mvnoStatus ? iccidStatusHelper.getName(item.mvnoStatus) : null;
                    if (statusString) {
                        statusString = i18next.t(statusString).toString();
                    }
                    return (
                        <TableRow
                            classes={tableRowRoot}
                            key={'key' + item.id}
                            hover
                            onClick={(): void => {
                                setActiveRow(item.id);
                            }}
                            style={{ backgroundColor: rowActiveColor }}
                        >
                            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                                <ViewButton
                                    callback={viewCallback}
                                    callbackParam={{ uri: item['@id'] }}
                                    tooltipTitle="pools:add.iccid_view"
                                    tooltipPlacement="bottom-start"
                                />
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.iccid}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.imsi}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.iccidType}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.lastmsisdn === null && item.msisdn}
                                {item.lastmsisdn}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {<I18n trans={iccidStatus(item.iccidState)} />}
                            </TableCell>
                            {/*<TableCell classes={tableCellRoot} padding="none" align="left">*/}
                            {/*    {item.defaultTariff && simCardMnoTariffLoader.getName(parseInt(item.defaultTariff))}*/}
                            {/*</TableCell>*/}
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.puk1}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.puk2}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.pin1}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.pin2}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.esimUpdate && DateHelperTs.format(item.esimUpdate, 'YYYY-MM-DD')}
                            </TableCell>
                            {/*<TableCell classes={tableCellRoot} padding="none" align="left">*/}
                            {/*    {statusString}*/}
                            {/*</TableCell>*/}
                        </TableRow>
                    );
                })}
            </TableBody>
        </React.Fragment>
    );
};
